// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"88ef970c","453":"73603cda","455":"b1c4feff","715":"cef2ae97","779":"6627054b"}[chunkId] + ".chunk.js";
};